import type { ISelection } from "@/types/centra";
import { GroupSubItem, ItemGroup } from "./formatting/formatSelection";

const optimisticUpdate = (
  data: any,
  variables: { newQuantity: number; line: string }
): ISelection => {
  const itemGroups = data?.selection?.items || [];

  const matchedItemGroup = itemGroups.find(
    (item: ItemGroup) =>
      item.id === variables.line || item?.itemsIds?.includes(variables.line)
  );

  if (matchedItemGroup === -1) return data;

  const updatedItems = itemGroups.reduce(
    (acc: ItemGroup[], group: ItemGroup) => {
      if (group.id === matchedItemGroup.id) {
        const updatedGroup = group.items.map((item: GroupSubItem) => {
          if (item.id === variables.line) {
            return {
              ...item,
              quantity: variables.newQuantity
            };
          }
          return item;
        });

        // Check if all subItems have quantity 0
        const isZeroQuantityGroup = updatedGroup.every(
          (item) => item.quantity === 0
        );

        // If all subItems have quantity 0, skip the group
        if (isZeroQuantityGroup) {
          return acc;
        }

        // Add the updated group to the accumulator
        return [
          ...acc,
          {
            ...group,
            items: updatedGroup
          }
        ];
      } else {
        // If the group id does not match, add the group to the accumulator
        return [...acc, group];
      }
    },
    []
  );

  const formattedData = {
    ...data,
    selection: {
      ...data.selection,
      items: updatedItems
    }
  };

  return formattedData;
};

export default optimisticUpdate;
